import gql from 'graphql-tag'
import { viewerFragment } from 'api/fragments'

export const HOST_ENTRY_QUERY = gql`
  query HostEntryPage {
    viewer {
      ${viewerFragment}
    }
  }
`
